// if (!customElements.get('product-form')) {
//   customElements.define(
//     'product-form',
//     class ProductForm extends HTMLElement {
//       constructor() {
//         super();

//         this.form = this.querySelector('form');
//         this.variantIdInput.disabled = false;
//         this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
//         this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
//         this.submitButton = this.querySelector('[type="submit"]');
//         this.submitButtonText = this.submitButton.querySelector('span');

//         if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

//         this.hideErrors = this.dataset.hideErrors === 'true';
//       }

//       onSubmitHandler(evt) {
//         evt.preventDefault();
//         if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

//         this.handleErrorMessage();

//         this.submitButton.setAttribute('aria-disabled', true);
//         this.submitButton.classList.add('loading');
//         this.querySelector('.loading__spinner').classList.remove('hidden');

//         const config = fetchConfig('javascript');
//         config.headers['X-Requested-With'] = 'XMLHttpRequest';
//         delete config.headers['Content-Type'];

//         const formData = new FormData(this.form);
//         if (this.cart) {
//           formData.append(
//             'sections',
//             this.cart.getSectionsToRender().map((section) => section.id)
//           );
//           formData.append('sections_url', window.location.pathname);
//           this.cart.setActiveElement(document.activeElement);
//         }
//         config.body = formData;

//         fetch(`${routes.cart_add_url}`, config)
//           .then((response) => response.json())
//           .then((response) => {
//             if (response.status) {
//               publish(PUB_SUB_EVENTS.cartError, {
//                 source: 'product-form',
//                 productVariantId: formData.get('id'),
//                 errors: response.errors || response.description,
//                 message: response.message,
//               });
//               this.handleErrorMessage(response.description);

//               const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
//               if (!soldOutMessage) return;
//               this.submitButton.setAttribute('aria-disabled', true);
//               this.submitButtonText.classList.add('hidden');
//               soldOutMessage.classList.remove('hidden');
//               this.error = true;
//               return;
//             } else if (!this.cart) {
//               window.location = window.routes.cart_url;
//               return;
//             }

//             if (!this.error)
//               publish(PUB_SUB_EVENTS.cartUpdate, {
//                 source: 'product-form',
//                 productVariantId: formData.get('id'),
//                 cartData: response,
//               });
//             this.error = false;
//             const quickAddModal = this.closest('quick-add-modal');
//             if (quickAddModal) {
//               document.body.addEventListener(
//                 'modalClosed',
//                 () => {
//                   setTimeout(() => {
//                     this.cart.renderContents(response);
//                   });
//                 },
//                 { once: true }
//               );
//               quickAddModal.hide(true);
//             } else {
//               this.cart.renderContents(response);
//             }
//           })
//           .catch((e) => {
//             console.error(e);
//           })
//           .finally(() => {
//             this.submitButton.classList.remove('loading');
//             if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
//             if (!this.error) this.submitButton.removeAttribute('aria-disabled');
//             this.querySelector('.loading__spinner').classList.add('hidden');
//           });
//       }

//       handleErrorMessage(errorMessage = false) {
//         if (this.hideErrors) return;

//         this.errorMessageWrapper =
//           this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
//         if (!this.errorMessageWrapper) return;
//         this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

//         this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

//         if (errorMessage) {
//           this.errorMessage.textContent = errorMessage;
//         }
//       }

//       toggleSubmitButton(disable = true, text) {
//         if (disable) {
//           this.submitButton.setAttribute('disabled', 'disabled');
//           if (text) this.submitButtonText.textContent = text;
//         } else {
//           this.submitButton.removeAttribute('disabled');
//           this.submitButtonText.textContent = window.variantStrings.addToCart;
//         }
//       }

//       get variantIdInput() {
//         return this.form.querySelector('[name=id]');
//       }
//     }
//   );
// }


if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');

        if (!this.form) return;

        if (this.variantIdInput) {
          this.variantIdInput.disabled = false;
        }

        this.form.addEventListener(
          'submit',
          this.onSubmitHandler.bind(this)
        );

        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        this.submitButton =
          this.querySelector('[type="submit"]');

        if (!this.submitButton) return;

        this.submitButtonText =
          this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute(
            'aria-haspopup',
            'dialog'
          );
        }

        this.hideErrors =
          this.dataset.hideErrors === 'true';

        this.error = false;
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();

        if (!this.submitButton) return;

        if (
          this.submitButton.getAttribute(
            'aria-disabled'
          ) === 'true'
        ) {
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute(
          'aria-disabled',
          'true'
        );

        this.submitButton.classList.add('loading');

        const spinner =
          this.querySelector('.loading__spinner');

        if (spinner) {
          spinner.classList.remove('hidden');
        }

        try {
          /*
           * ==========================================
           * PURCHASE OPTION DATA
           * ==========================================
           */

          const purchaseOption =
            this.form.dataset.purchaseOption || '';

          const addonVariantId =
            this.form.dataset.addonVariantId || '';

          const isPurchaseOptionsForm =
            this.form.dataset.purchaseOptionsEnabled === 'true';

          const isBundlePurchase =
            isPurchaseOptionsForm &&
            purchaseOption === 'even-tone';

          if (isBundlePurchase && !addonVariantId) {
            throw new Error('The bundle add-on is unavailable. Please choose another purchase option.');
          }

          /*
           * ==========================================
           * ORIGINAL SHOPIFY FORM DATA
           * ==========================================
           *
           * IMPORTANT:
           *
           * new FormData(this.form) automatically
           * includes:
           *
           * id
           * quantity
           * properties[...]
           * selling_plan
           *
           * So subscription needs NO separate
           * cart request.
           * ==========================================
           */

          const formData =
            new FormData(this.form);

          if (
            isPurchaseOptionsForm &&
            purchaseOption !== 'subscription'
          ) {
            formData.delete('selling_plan');
          }

          /*
           * Remove an empty selling_plan.
           *
           * One-time purchase should not send:
           * selling_plan=""
           */
          if (
            formData.has('selling_plan') &&
            !formData.get('selling_plan')
          ) {
            formData.delete('selling_plan');
          }

          /*
           * ==========================================
           * ORIGINAL SHOPIFY FETCH CONFIG
           * ==========================================
           */

          const config =
            fetchConfig('javascript');

          config.headers[
            'X-Requested-With'
          ] = 'XMLHttpRequest';

          let sections = [];

          /*
           * ==========================================
           * ORIGINAL CART DRAWER SUPPORT
           * ==========================================
           */

          if (this.cart) {
            sections =
              this.cart
                .getSectionsToRender()
                .map(
                  (section) =>
                    section.id
                );

            /*
             * Dawn normally accepts comma-separated
             * section IDs.
             */
            if (
              typeof this.cart
                .setActiveElement ===
              'function'
            ) {
              this.cart.setActiveElement(
                document.activeElement
              );
            }
          }

          if (isBundlePurchase) {
            const mainVariantId = Number(formData.get('id'));
            const addonId = Number(addonVariantId);
            const requestedQuantity = Number(formData.get('quantity') || 1);
            const quantity = Number.isInteger(requestedQuantity) && requestedQuantity > 0
              ? requestedQuantity
              : 1;

            if (!Number.isInteger(mainVariantId) || !Number.isInteger(addonId)) {
              throw new Error('The selected bundle is invalid. Please refresh the page and try again.');
            }

            const bundlePayload = {
              items: [
                { id: mainVariantId, quantity },
                { id: addonId, quantity }
              ]
            };

            if (sections.length) {
              bundlePayload.sections = sections.join(',');
              bundlePayload.sections_url = window.location.pathname;
            }

            config.headers['Content-Type'] = 'application/json';
            config.body = JSON.stringify(bundlePayload);
          } else {
            delete config.headers['Content-Type'];

            if (sections.length) {
              formData.set('sections', sections.join(','));
              formData.set('sections_url', window.location.pathname);
            }

            config.body = formData;
          }

          /*
           * ==========================================
           * ORIGINAL MAIN PRODUCT ADD
           * ==========================================
           */

          const response =
            await fetch(
              `${routes.cart_add_url}`,
              config
            );

          const responseData =
            await response.json();

          if (isBundlePurchase && Array.isArray(responseData.items) && responseData.items.length) {
            responseData.id = responseData.items[0].id;
            responseData.key = responseData.items[0].key;
          }

          /*
           * ==========================================
           * ERROR RESPONSE
           * ==========================================
           */

          if (
            !response.ok ||
            responseData.status
          ) {
            if (
              typeof publish ===
                'function' &&
              typeof PUB_SUB_EVENTS !==
                'undefined' &&
              PUB_SUB_EVENTS.cartError
            ) {
              publish(
                PUB_SUB_EVENTS.cartError,
                {
                  source:
                    'product-form',

                  productVariantId:
                    formData.get('id'),

                  errors:
                    responseData.errors ||
                    responseData.description,

                  message:
                    responseData.message
                }
              );
            }

            this.handleErrorMessage(
              responseData.description ||
                responseData.message ||
                'Unable to add product to cart.'
            );

            const soldOutMessage =
              this.submitButton.querySelector(
                '.sold-out-message'
              );

            if (soldOutMessage) {
              this.submitButton.setAttribute(
                'aria-disabled',
                'true'
              );

              if (
                this.submitButtonText
              ) {
                this.submitButtonText
                  .classList.add(
                    'hidden'
                  );
              }

              soldOutMessage
                .classList.remove(
                  'hidden'
                );
            }

            this.error = true;

            return;
          }

          /*
           * ==========================================
           * NO CART DRAWER
           * ==========================================
           */

          if (!this.cart) {
            window.location =
              window.routes &&
              window.routes.cart_url
                ? window.routes.cart_url
                : '/cart';

            return;
          }

          /*
           * ==========================================
           * ORIGINAL CART UPDATE EVENT
           * ==========================================
           */

          if (
            typeof publish ===
              'function' &&
            typeof PUB_SUB_EVENTS !==
              'undefined' &&
            PUB_SUB_EVENTS.cartUpdate
          ) {
            publish(
              PUB_SUB_EVENTS.cartUpdate,
              {
                source:
                  'product-form',

                productVariantId:
                  formData.get('id'),

                cartData:
                  responseData
              }
            );
          }

          this.error = false;

          /*
           * ==========================================
           * ORIGINAL QUICK ADD SUPPORT
           * ==========================================
           */

          const quickAddModal =
            this.closest(
              'quick-add-modal'
            );

          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  if (
                    this.cart &&
                    typeof this.cart
                      .renderContents ===
                    'function'
                  ) {
                    this.cart.renderContents(
                      responseData
                    );
                  }
                });
              },
              {
                once: true
              }
            );

            quickAddModal.hide(true);
          } else {
            /*
             * IMPORTANT:
             *
             * Give the cart drawer the ORIGINAL
             * Shopify cart/add response.
             *
             * Do not construct our own
             * response/sections object.
             */
            if (
              this.cart &&
              typeof this.cart
                .renderContents ===
                'function'
            ) {
              this.cart.renderContents(
                responseData
              );
            }
          }
        } catch (error) {
          console.error(
            'Product form error:',
            error
          );

          this.error = true;

          this.handleErrorMessage(
            error &&
              error.message
              ? error.message
              : 'Unable to add product to cart.'
          );

          if (
            typeof publish ===
              'function' &&
            typeof PUB_SUB_EVENTS !==
              'undefined' &&
            PUB_SUB_EVENTS.cartError
          ) {
            publish(
              PUB_SUB_EVENTS.cartError,
              {
                source:
                  'product-form',

                productVariantId:
                  this.variantIdInput
                    ? this
                        .variantIdInput
                        .value
                    : null,

                errors:
                  error &&
                  error.message
                    ? error.message
                    : 'Cart error',

                message:
                  error &&
                  error.message
                    ? error.message
                    : 'Cart error'
              }
            );
          }
        } finally {
          this.submitButton
            .classList.remove(
              'loading'
            );

          /*
           * Don't manually rebuild cart HTML.
           * Only preserve Dawn's empty-state flag.
           */

          if (
            this.cart &&
            this.cart.classList.contains(
              'is-empty'
            ) &&
            !this.error
          ) {
            this.cart.classList.remove(
              'is-empty'
            );
          }

          if (!this.error) {
            this.submitButton
              .removeAttribute(
                'aria-disabled'
              );
          }

          const spinner =
            this.querySelector(
              '.loading__spinner'
            );

          if (spinner) {
            spinner.classList.add(
              'hidden'
            );
          }
        }
      }

      /*
       * ==========================================
       * ORIGINAL ERROR MESSAGE
       * ==========================================
       */

      handleErrorMessage(
        errorMessage = false
      ) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            '.product-form__error-message-wrapper'
          );

        if (
          !this.errorMessageWrapper
        ) {
          return;
        }

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper
            .querySelector(
              '.product-form__error-message'
            );

        this.errorMessageWrapper
          .toggleAttribute(
            'hidden',
            !errorMessage
          );

        if (
          errorMessage &&
          this.errorMessage
        ) {
          this.errorMessage
            .textContent =
            errorMessage;
        }
      }

      /*
       * ==========================================
       * ORIGINAL SUBMIT BUTTON
       * ==========================================
       */

      toggleSubmitButton(
        disable = true,
        text
      ) {
        if (!this.submitButton) {
          return;
        }

        if (disable) {
          this.submitButton.setAttribute(
            'disabled',
            'disabled'
          );

          if (
            text &&
            this.submitButtonText
          ) {
            this.submitButtonText
              .textContent =
              text;
          }
        } else {
          this.submitButton
            .removeAttribute(
              'disabled'
            );

          if (
            this.submitButtonText &&
            window.variantStrings
          ) {
            this.submitButtonText
              .textContent =
              window.variantStrings
                .addToCart;
          }
        }
      }

      /*
       * ==========================================
       * VARIANT INPUT
       * ==========================================
       */

      get variantIdInput() {
        if (!this.form) {
          return null;
        }

        return this.form.querySelector(
          '[name=id]'
        );
      }
    }
  );
}
